import { initialize } from '@heytap/cloud-observation-rum'
import Util from './common-tools'

/**
 * 从 UA 字符串中获取指定参数值（支持 key:value 格式）
 * @param {string} name 参数名
 * @param {string} ua 可选，UA字符串，默认使用 navigator.userAgent
 * @returns {string|null} 参数值，未找到返回 null
 */
export function getUAParam(name, ua = navigator.userAgent) {
  // 匹配 key:value 格式，支持分号或字符串开始作为边界
  const reg = new RegExp('(;|^)\\s*' + name + '\\s*:([^;]*)')
  const result = ua.match(reg)
  if (result && result.length === 3) {
    return result[2].trim()
  }
  return null
}

const getResourceAttributes = new Promise(resolve => {
  const staticAttributes = {
    channelName: getUAParam('appCode') || 'webBrowser',
    appForm: 'MobileWeb',
    sceneType: 'Other'
  }
  if (!window.qing || !window.qing.isSupportNativeJsBridge) {
    return resolve(staticAttributes)
  }
  window.qing.call('mtp.getLoginUserInfo', {
    success: result =>
      resolve({
        ...staticAttributes,
        userId: result.data.jobNo
      }),
    error: err =>
      resolve({
        ...staticAttributes
      })
  })
})

export function initTelemetry() {
  if (!window.$env || !window.$env.CLOUD_MONITOR_URL) {
    return
  }
  try {
    initialize({
      collectionSourceUrl: window.$env.CLOUD_MONITOR_URL, // 协议+域名（应用接入页面根据接入环境返回）
      serviceName: 'my-favorite',
      deploymentEnvironment: Util.getEnv(),
      ignoreUrls: [/^https:\/\/dmg-dts-api(-test)?\.myoas.com\/.*/], // 忽略神策埋点上报url
      resouceAttributes: getResourceAttributes
    })
  } catch (error) {
    console.error('initTelemetry error', error)
  }
}
